import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import '../../styles/components/landing/SolutionSection.css';

const SolutionSection = ({ eyebrow, title, description, bullets = [], image }) => {
  return (
    <section className="ls-solution">
      <div className="container">
        <div className="ls-solution__grid">
          <motion.div
            className="ls-solution__text"
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {eyebrow && <span className="ls-solution__eyebrow">{eyebrow}</span>}
            <h2 className="ls-solution__title">{title}</h2>
            {description && <p className="ls-solution__description">{description}</p>}

            <ul className="ls-solution__bullets">
              {bullets.map((b, i) => (
                <li key={i}>
                  <CheckCircle2 size={18} />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {image && (
            <motion.div
              className="ls-solution__visual"
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <img
                src={image}
                alt=""
                onError={(e) =>
                  (e.target.src = 'https://placehold.co/600x600/10083B/FAFAFA?text=LifeUp')
                }
              />
              <div className="ls-solution__glow" />
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
